import { Alert } from "@mui/material";
import './Banner.css'
const Banner = ({content})=>{   
        return(
            <div>
            <Alert className="bannerStyle mt-4" severity="">
           <p dangerouslySetInnerHTML={{ __html: content}}></p> 
          </Alert>
          </div>  )}
export default Banner;